import type { Game } from '../../game/Game';
import { registerPanel } from '../../ui/app/App';
import { setGame } from '../economy/ui';
import './bounties.css';
import { bountySystem, registerSaved, restDay, wrapBattleItems } from './board';
import { BountyPanel } from './BountyPanel';

export { consumeRested, dailyCore, endgameUnlocked } from './dayCycle';
export { acceptBounty, bountyContext, claimBounty, restDay, syncCharacter } from './board';

/**
 * Bounty Board (`bounty` panel) and the session-day cycle: daily/weekly
 * bounties as quests, Rest (`game.restDay()`), real-time resets and the
 * Rested bonus.
 */
export function install(game: Game): void {
  setGame(game);
  registerPanel('bounty', BountyPanel);
  // Saved bounty quests must be known before the HUD asks for their definitions.
  registerSaved(game.account.characters);
  game.restDay = () => void restDay(game);
  wrapBattleItems(game);
  game.systems.push(bountySystem());
}
